import { kpiApi } from "@/api/kpiApi";
import Breadcrumbs from "@/components/Breadcrumbs";
import Loading from "@/components/feedback/Loading";
import SettingsIcon from "@mui/icons-material/Settings";
import { Box, Chip, Container, Divider, Tab, Tabs, Typography } from "@mui/material";
import { Outlet, Link as RouterLink, useMatch, useParams } from "react-router-dom";

export default function KpiViewerLayout() {
    const { kpiId } = useParams();

    const tabUrl = (tab) => `/kpis/${kpiId}/${tab}`;
    // const navigate = useNavigate();
    const matchPath = useMatch("/kpis/:kpiId/:tab/*");
    const currentTab = matchPath?.params.tab ?? "info";

    const kpi = kpiApi.endpoints.getKpiById.useQuery({ id: kpiId });
    const kpiData = kpi.data?.data;

    if (kpi.isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Container>
                <Breadcrumbs
                    items={[
                        { label: "KPIs", to: "/workspace/kpis" },
                        { label: `#${kpiId}`, to: `/kpis/${kpiId}` },
                    ]}
                />
            </Container>

            <Container>
                <Box>
                    <Typography variant="h1" fontSize="0.9em" color="grey">
                        KPI
                    </Typography>
                    {kpi.isLoading ? (
                        <Loading />
                    ) : (
                        <>
                            <Typography variant="h2" fontSize="1.2em" fontWeight="bold" gutterBottom>
                                {kpiData?.title ?? "n/a"}
                            </Typography>
                            <Box sx={{ display: "flex", gap: 0.5 }}>
                                {Boolean(kpiData?.kpi_code) && <Chip label={kpiData?.kpi_code} size="small" />}
                                <Chip label={kpiData?.kpi_type?.title} size="small" variant="outlined" />
                                <Divider orientation="vertical" flexItem />
                            </Box>
                        </>
                    )}
                </Box>

                <Tabs
                    value={currentTab}
                    sx={{
                        marginTop: 1,
                        borderBottom: 1,
                        borderColor: "divider",
                    }}
                >
                    <Tab component={RouterLink} label="Information" value="info" to={tabUrl("info")} />
                    <Tab component={RouterLink} label="Data" value="data" to={tabUrl("data")} />
                    <Tab
                        component={RouterLink}
                        label={
                            <Box display="inline-flex" alignItems="center">
                                <SettingsIcon fontSize="small" />
                                <span> Setting</span>
                            </Box>
                        }
                        value="settings"
                        to={tabUrl("settings")}
                    />
                </Tabs>
            </Container>

            {/** content */}
            {kpi.isLoading ? <Loading /> : <Outlet context={{ kpi }} />}
        </>
    );
}
